/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_c0bc60c0"]'><div><cube-button @_click="show">content-popup</cube-button><cube-popup ref="__mpx_ref_popup__" :maskClosable="(true)" content="<i style='color:#fc9153'>Hello World</i>" :maskFadeTransition="(true)" transition="move-center" :styleConfig="(styleConfig)" :class='["cube-extend-popup"]'></cube-popup></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_c0bc60c0"}'>
.cube-extend-popup
  .cube-popup-content
    padding: 20px
    color: #fff
    background-color: rgba(0, 0, 0, .8)
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_c0bc60c0"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_c0bc60c0"}
  /** script content **/
  require("./popup-content.mpx.js?isComponent&outputPath=components%2Fpopup-contentc0bc60c0%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./popup-content.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fpopup-contentc0bc60c0%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_c0bc60c0"],
    ctorType: "component",
    outputPath: "components/popup-contentc0bc60c0/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-popup':getComponent(require("../../../packages/mpx-cube-ui/src/components/popup/index.mpx?isComponent&outputPath=components%2Findex106ca599%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>